export default __webpack_public_path__ + "static/media/B190.db395374.png";